<template>
  <div class="w-screen flex bg-gray-200">
    <navigation v-if="authenticatedUser"></navigation>
    <div v-if="currentOrg" class="h-full w-screen flex bg-gray-200">
      <router-view />
    </div>
    <div v-if="!currentOrg" class="h-full w-screen flex bg-gray-200">
      Loading...
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation'

export default {
  name: 'App',
  components: {
    Navigation
  },
  data () {
    return {
      message: ''
      //
    }
  },
  computed: {
    authenticatedUser () {
      return (this.$store.state.auth.user && this.$store.state.auth.user.verifiedOTP)
    },
    currentOrg () {
      return this.$store.state.init.org
    }
  },
  created () {
    if (this.$route.params.orgName) {
      console.log(`confirming org: ${this.$route.params.orgName}`)
      this.$store.dispatch('init/populate', this.$route.params.orgName).then(
        () => {
          console.log(this.$store.state.init.org)
        },
        error => {
          this.message =
            (error.response && error.response.data) ||
            error.message ||
            error.toString()
        }
      )
    } // TODO - else navigate to selection page?
  }
}
</script>
